/* eslint-disable */

/**
 *
 * sorry ^^^
 *
 * Eats dataset, creates gtm events
 * @type {{init: (function(): boolean), setEventListeners: (function(): boolean), pushToDataLayer: gtmEventPusher.pushToDataLayer}}
 * @author Mikko Lehmusjoki
 *
 * @example
 * Automagic, only add HTML
 *
 * <form class="gtm-events"
 *       data-gtm-event-trigger="submit"
 *       data-gtm-event-category="Car page"
 *       data-gtm-event-action="Submit"
 *       data-gtm-event-label="Bestest form"
 * >
 *
 */

export default {
  /**
   * Find elements that want to use this module
   * @returns {boolean}
   */
  init : function(parentElement = document) {
    this.gtmEventElements = parentElement.getElementsByClassName('gtm-events');
    if (this.gtmEventElements.length) {
      this.setEventListeners();
    }
    return true;
  },
    /**
     * Set event listeners for elements that want to use this module
     * @returns {boolean}
     */
  setEventListeners : function() {
    for (let i = 0; i < this.gtmEventElements.length; i++) {
      const gtmEventElement = this.gtmEventElements[i],
        event           = gtmEventElement.dataset.gtmEventTrigger || false,
        self            = this;
      if (!event) {
        continue;
      }
      gtmEventElement.addEventListener(event, function(event) {
        if (gtmEventElement.tagName.toLowerCase() === 'a') {
          event.preventDefault();
          self.pushToDataLayer(gtmEventElement);
          window.setTimeout(() => {
                          if( gtmEventElement.target === '_blank') {
                            window.open(gtmEventElement.href);
                          } else {
                            window.location = gtmEventElement.href
                          }
                        }, 100 );
        } else {
          self.pushToDataLayer(gtmEventElement);
        }
      });
    }
    return true;
  },
    /**
     * Send gtm events
     * @param gtmEventElement
     * @returns {boolean}
     */
  pushToDataLayer : function(gtmEventElement) {
    if ((!gtmEventElement.dataset.hasOwnProperty('gtmEventCategory')
            && !gtmEventElement.dataset.hasOwnProperty('gtmEventAction')
            && !gtmEventElement.dataset.hasOwnProperty('gtmEventLabel'))) {
      return false;
    }

        /*
        * untested but concept verified to work
        * let eventLabel = gtmEventElement.dataset.gtmEventLabel;
        *
        * for example:
        * <form>
        *     <input type="checkbox"
        *            value="uliuli"
        *            name="_uu"
        *            data-gtm...
        *            ...
        *            data-gtm-attributes-to-label="name, value"
        *     >
        *     ...
        * </form>


        if (gtmEventElement.dataset.hasOwnProperty('gtmEventAttributesToLabel')) {
            const attributesArray = gtmEventElement.dataset.gtmEventAttributesToLabel.split(', ');
            for (let i = 0; i < attributesArray.length; i++) {
                eventLabel += ' ' + attributesArray[0] + ': ' + gtmEventElement[attributesArray[0]];
            }
        }

        end untested */

    const event = {
      event          : 'GAEvent',
      eventCategory  : gtmEventElement.dataset.gtmEventCategory,
      eventAction    : gtmEventElement.dataset.gtmEventAction,
      eventLabel     : gtmEventElement.dataset.gtmEventLabel + (gtmEventElement.dataset.gtmEventIncludeValue === 'true' ? ': ' + gtmEventElement.value : ''),
      nonInteraction : false
    };

    return this._pushToDatalayer(event);
  },

    /**
    * Push events to datalayer
    *
    * @param {object} event, event object
    * @returns {boolean} true
    */
    _pushToDatalayer(event) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(event);

      return true;
    },

    /**
    * formating GA events to datalayer
    *
    * @param {string} categoryName, catagory name like Carsearch or SearchReminder
    * @param {string} category, usualy 'extended' or 'simple'
    * @param {string} action, events action like Search
    * @param {string} name, elements name
    * @param {string} value, elements value
    * @param {boolean} nonInteraction, is event interaction
    * @returns {object} event to datalayer
    */
    formatGAEventToDataLayer(categoryName, category, action, name, value, nonInteraction = false) {
      return this._pushToDatalayer({
        event          : 'GAEvent',
        eventCategory  : `${categoryName} - ${category}`,
        eventAction    : action,
        eventLabel     : `${name}: ${value}`,
        nonInteraction : nonInteraction
      });
    }
};
